import packageJson from 'package.json';
import { environment } from '../../environments/environment';
// Note: do not check in over this. When we run locally, we will be able to identify local testing using this.
export const buildInfo = {
  name: 'TripPortal',
  ionicAppId: environment.ionicAppId,
  ionicAppChannel: `dev.${packageJson.version}[0]`,
  publicVersion: packageJson.version,
  internalVersion: '2026.09.03-10.44.23.469',
  date: '2026-09-03T10:44:23.469Z',
};
